"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateLoanProductMap = void 0;
const common_1 = require("@finley-technologies/common");
const createEmptyLoanProductData = () => ({
    externalReceivableIds: [],
    assetValuation: 0,
    loanProductReport: {
        effectiveReceivableAdvanceRate: 0,
        effectiveReceivableValuationRate: 0,
        totalConcentrationKickout: 0,
        totalEligibilityKickout: 0,
        totalEligibleExposure: 0,
        totalEligibleExposureLessConcentrationKickouts: 0,
        totalReceivableBorrowingBaseAmount: 0,
        totalReceivableExposure: 0,
        weightedAverageReceivableAdvanceRate: 0,
    },
});
const updateLoanProductMap = ({ loanProductMap, receivable, }) => {
    // Get existing data or create empty shell
    const loanProductData = loanProductMap.get(receivable.loanProductId) ??
        createEmptyLoanProductData();
    // Update list of external IDs for loan product
    loanProductData.externalReceivableIds.push(receivable.externalReceivableId);
    // Update asset valuation
    loanProductData.assetValuation += receivable.valuationFields.valuation;
    // Update loan product report
    const currentReport = loanProductData.loanProductReport;
    // *** Receivable calculations ***
    const totalEligibleExposureLessConcentrationKickouts = currentReport.totalEligibleExposureLessConcentrationKickouts +
        receivable.concentrationLimitFields
            .eligibleExposureLessConcentrationLimitKickouts;
    const totalReceivableBorrowingBaseAmount = currentReport.totalReceivableBorrowingBaseAmount +
        receivable.borrowingBaseFields.borrowingBaseAmount;
    const totalReceivableExposure = currentReport.totalReceivableExposure +
        receivable.requiredIntermediateFields.exposure;
    const totalEligibleExposure = currentReport.totalEligibleExposure +
        receivable.eligibilityFields.eligibleExposure;
    // *** Aggregate calculations (using receivable calculations) ***
    const totalEligibilityKickout = totalReceivableExposure - totalEligibleExposure;
    const totalConcentrationKickout = totalEligibleExposure - totalEligibleExposureLessConcentrationKickouts;
    const effectiveReceivableValuationRate = common_1.utils.divideByOrZero(loanProductData.assetValuation, totalReceivableExposure);
    const effectiveReceivableAdvanceRate = common_1.utils.divideByOrZero(totalReceivableBorrowingBaseAmount, totalReceivableExposure);
    const weightedAverageReceivableAdvanceRate = common_1.utils.divideByOrZero(totalReceivableBorrowingBaseAmount, totalEligibleExposureLessConcentrationKickouts);
    // Aggregate calculations using results of receivable calculations above
    loanProductData.loanProductReport = {
        effectiveReceivableAdvanceRate,
        effectiveReceivableValuationRate,
        totalConcentrationKickout,
        totalEligibleExposure,
        totalEligibleExposureLessConcentrationKickouts,
        totalEligibilityKickout,
        totalReceivableBorrowingBaseAmount,
        totalReceivableExposure,
        weightedAverageReceivableAdvanceRate,
    };
    // In case this was not already present, set the data in the map again
    loanProductMap.set(receivable.loanProductId, loanProductData);
};
exports.updateLoanProductMap = updateLoanProductMap;
//# sourceMappingURL=loanProductReport.js.map